/**
 * API 配置 - 单一数据源，避免 env 解析异常导致请求错误
 *
 * 设计原则：
 * 1. 开发环境：固定使用 /api，由 vue.config.js 代理到后端
 * 2. 生产环境：仅当 env 为合法 URL 时使用，否则用默认值
 * 3. 不做字符串拼接或 replace，杜绝注释、空格等污染
 */

const isProduction = process.env.NODE_ENV === "production";

/** 清洗 env 值：去除引号、注释、空格等污染 */
function sanitizeEnvUrl(val) {
  if (typeof val !== "string" || !val.trim()) return "";
  const s = String(val)
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .split(/\s*\/\/|\s+#/)[0]
    .trim();
  return s;
}

/** 判断是否为合法完整 URL */
function isValidApiUrl(val) {
  const s = sanitizeEnvUrl(val);
  return s.startsWith("http://") || s.startsWith("https://");
}

/** 从 env 安全读取生产环境 API 地址 */
function getProductionApiUrl() {
  const s = sanitizeEnvUrl(process.env.VUE_APP_API_URL);
  if (!isValidApiUrl(s)) {
    // 默认同源相对路径：网页打自己的源站，由各环境 nginx 代理到本机 svr
    // （demo.luxiaoguo.cn→122、yitinglink.com→47）。跨源部署时用 VUE_APP_API_URL 覆盖为绝对地址。
    return "/api";
  }
  return s.replace(/\/yt-sys\/?$/, "");
}

/**
 * 登录/注册等根 API 地址
 * - 开发: /api -> 代理到 localhost:8091
 * - 生产: 默认同源相对 /api（经各环境 nginx 代理到本机 svr）；可用 VUE_APP_API_URL 覆盖为绝对地址
 */
export const apiBase = isProduction ? getProductionApiUrl() : "/api";

/**
 * 业务 API 地址（/yt-sys 前缀）
 * - 开发: /api/yt-sys
 * - 生产: 默认同源相对 /api/yt-sys（同上）
 */
export const ytSysBase = isProduction ? getProductionApiUrl() + "/yt-sys" : "/api/yt-sys";
